import React from 'react';
import { motion } from 'framer-motion';
import HeroContent from './HeroContent';
import { useSiteImages } from '../context/SiteImagesContext';

const FALLBACK_PHONE = "https://media-manager-c.questera.ai/greta-media/ab03ff55dc7bcdd9e4a34a93308a2aa656b3e0baf34844f0be8f244dd21175025656600d9573a40a26a1591403a49a1d/images/aW1hZ2UvcG5n/cff60eca1aefc3a91cc5a3cc3b9354d3.png";

const Hero = () => {
  const { getImage } = useSiteImages();
  const phoneImage = getImage('hero-phone', FALLBACK_PHONE);

  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-white">
      {/* Background FITPAIR text - desktop only */}
      <div className="hidden lg:block absolute inset-0 pointer-events-none select-none overflow-hidden z-0">
        <div className="absolute top-1/2 left-[62%] -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="text-[18vw] font-black leading-[0.85] tracking-tighter text-brand-red"
            aria-hidden="true"
          >
            FIT
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
            className="text-[18vw] font-black leading-[0.85] tracking-tighter text-brand-red opacity-0"
            aria-hidden="true"
          >
            PAIR
          </motion.div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full relative z-10">
        <div className="relative">
          {/* Phone Image - positioned behind text with 3D overlap */}
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.8, type: "spring", stiffness: 50 }}
            className="
              absolute z-0
              right-0 top-4
              w-[180px] sm:w-[240px] md:w-[300px]
              lg:right-0 lg:top-0 lg:w-[400px] xl:w-[460px]
            "
          >
            <motion.div
              animate={{ y: [-15, 15, -15] }}
              transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
              className="w-full relative"
            >
              <img
                src={phoneImage}
                alt="FitPair fitness app preview showing workout buddy matching and daily challenges on mobile"
                className="w-full h-auto object-contain drop-shadow-[0_35px_35px_rgba(0,0,0,0.25)]"
                width="480"
                height="960"
                loading="eager"
                fetchpriority="high"
              />
            </motion.div>
          </motion.div>

          {/* Text Content - in front of phone (higher z-index) */}
          <div className="relative z-10 w-full max-w-xl">
            <HeroContent />
          </div>
        </div>
      </div>

      {/* PAIR text in front of phone - desktop only */}
      <div className="hidden lg:block absolute top-1/2 left-[62%] -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none z-20">
        <div className="flex flex-col items-center">
          <div
            className="text-[18vw] font-black leading-[0.85] tracking-tighter opacity-0"
            aria-hidden="true"
          >
            FIT
          </div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
            className="text-[18vw] font-black leading-[0.85] tracking-tighter text-brand-red"
            aria-hidden="true"
          >
            PAIR
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;